"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GraphOptions = /** @class */ (function () {
    function GraphOptions() {
        var _this = this;
        this.width = 500;
        this.height = 500;
        this.radius = 5;
        this.data = Promise.resolve({});
        this.distance = function () { return 50; };
        this.collision = function () { return _this.radius * 1.4; };
        this.charge = function () { return -20; };
        this.fontSize = 10;
    }
    return GraphOptions;
}());
exports.default = GraphOptions;
